import React from 'react';
import { ImageOptimizeProps } from './interface';
import ImageColOptimize from './ImageColOptimize';
import ImageSplitOptimize from './ImageSplitOptimize';
import './style/index.css';

export default function Select({ type, ...props }: ImageOptimizeProps) {
  if (type === 'col') {
    return  <ImageColOptimize  {...props} />;
  }
  return  <ImageSplitOptimize {...(props as ImageOptimizeProps)} />;  //  default
}
